import Link from 'next/link';
import styled from 'styled-components';

import { ApiSocialIssue } from '~/api/v1/social_issue_categories/get-type';
import { SusnetImage } from '~/components/_wrapper/SusnetImage';
import { media } from '~/utils';

type Props = {
  isSmall?: boolean;
  socialIssue: ApiSocialIssue;
};

export function CardSocialIssue({ socialIssue, isSmall = false }: Props) {
  const color = socialIssue.font_color
    ? socialIssue.font_color
    : socialIssue.type === 'GeneralSocialIssue'
    ? '#4E4E4E'
    : '#FFF';

  return (
    <StyledWrapper
      color={socialIssue.type === 'GeneralSocialIssue' ? socialIssue.color : 'none'}
      isSmallWidth={isSmall}
      href={`/social-issues/${socialIssue.id}`}
    >
      <StyledImageBox>
        <SusnetImage src={socialIssue.image} alt={socialIssue.name} fill sizes='100vw' />
      </StyledImageBox>
      <StyledCardSecondaryBody isSmallGap={isSmall}>
        <StyledCardSecondaryBodyTitle color={color} isSmallFont={isSmall}>
          {socialIssue.display_name || socialIssue.name}
        </StyledCardSecondaryBodyTitle>
        {!isSmall && (
          <StyledCardSecondaryBodyText color={color}>もっと詳しく</StyledCardSecondaryBodyText>
        )}
      </StyledCardSecondaryBody>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Link)<{ color?: string; isSmallWidth: boolean }>`
  aspect-ratio: 47 / 60;
  background-color: ${(props) => props.color || '#fff'};
  border-radius: 12px;

  cursor: pointer;
  display: block;
  position: relative;
  transition: 0.3s all;
  width: 100%;
  max-width: ${(props) => (props.isSmallWidth ? '130px' : '235px')};

  &:hover {
    filter: brightness(1.05);
  }
`;

const StyledImageBox = styled.div`
  aspect-ratio: 47 / 60;
  height: 100%;
  position: relative;
  width: 100%;

  img {
    border-radius: 12px;
    object-fit: cover;
  }
`;

const StyledCardSecondaryBody = styled.div<{ isSmallGap: boolean }>`
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.isSmallGap ? '6px' : '10px')};
  justify-content: center;
  padding: 8px;
  position: absolute;
  width: 100%;

  ${media.tbMin`
    padding: ${(props: { isSmallGap: boolean }) => (props.isSmallGap ? '6px' : '12px')};
  `}
`;

const StyledCardSecondaryBodyTitle = styled.p<{ color: string; isSmallFont: boolean }>`
  color: ${(props) => props.color};
  font-size: ${(props) => (props.isSmallFont ? '10px' : '16px')};
  font-weight: bold;
  line-height: 1.3;
  text-align: center;
  white-space: pre-line;

  ${media.tbMin`
    font-size: ${(props: { isSmallFont: boolean }) => (props.isSmallFont ? '12px' : '20px')};
  `}
`;

const StyledCardSecondaryBodyText = styled.p`
  color: ${(props) => props.color};
  font-size: 10px;
  font-weight: bold;
  line-height: 1.3;
  text-decoration: underline;
  white-space: pre-line;

  ${media.tbMin`
    font-size: 12px;
  `}
`;
